import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient} from '@angular/common/http';

import { routes } from './app.routes';
import {ApiConfigService} from './services/config.service';
import {BcGqlConfigService} from '@betterchains/bc-gql';
import {environment} from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: ApiConfigService,
      useValue: {
        production: false,
        isLocalhost: true,
        apiUrl:  environment.apiUrl,
        routes: []
      },
    },
    {
      provide: BcGqlConfigService,
      useValue: {
        isLocalhost: false,
        apiUrl: environment.apiUrl,
        staticUrl: environment.staticUrl,
      }
    }
  ]
};
